import './Spinner.css';
import React from 'react';
import classnames from 'classnames';

interface SpinnerParams {
  size?: 'small' | 'large' | number;
  color?: 'white'
}

export default function Spinner({ size = 'large', color }: SpinnerParams) {
  const spinnerClass = classnames(
    'Spinner',
    `Spinner--size--${size}`,
    color &&
    `Spinner--color--${color}`
  );

  return (
    <div className={spinnerClass}></div>
  );
}